import React, { useMemo, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/utils/Button";
import Table from "../../components/utils/Table";
import Modal from "../../components/utils/Modal";
import CardLayout from "../../components/utils/CardLayout";
import { useDispatch, useSelector } from "react-redux";
import reportActions from "../../redux/reports/actions";
import { downloadExcelSampleFile } from "../../helpers/commonFunction";
import QRCode from "react-qr-code";
const { getactivationBatchReports } = reportActions;

const ActivationBatchDetails = ({ selectedBatchId, onBack }) => {
    const dispatch = useDispatch();
    const [searchItem, setSearchItem] = useState("");
    const [showQRModal, setShowQRModal] = useState(false);
    const [selectedQrData, setSelectedQrData] = useState({});
    const beforeTwoDays = new Date();
    beforeTwoDays.setDate(beforeTwoDays.getDate() - 2);
    const formatDate = (date) => date.toISOString().split("T")[0];
    const { activationBatchReports, activationBatchReportsLoading, } = useSelector((state) => state.reports)
    const { defaultCurrency } = useSelector((state) => state.auth);

    const { formState: { errors } } = useForm({
        mode: "onChange",
        defaultValues: {
            batchID: "",
            isBatchDetail: true,
        },
    });

    useEffect(() => {
        if (selectedBatchId) {
            dispatch(getactivationBatchReports({
                batchID: selectedBatchId,
                isBatchDetail: true,
            }));
        }
    }, [selectedBatchId]);

    const handleQRClick = (data) => {
        setSelectedQrData(data);
        setShowQRModal(true);
    };
    const handleCloseQR = () => {
        setShowQRModal(false);
        setSelectedQrData({});
    };

    const columns = [
        { displayName: "Batch ID", key: "BATCHID" },
        { displayName: "Type", key: "TxnType" },
        { displayName: "Transaction ID", key: "TXNID" },
        { displayName: "Serial Number", key: "SERIALNUMBER" },
        { displayName: "MSISDN", key: "MSISDN" },
        { displayName: "Status", key: "Status" },
        { displayName: "Description", key: "DESCRIPTION" },
        { displayName: "Month", key: "MONTHTEXT" },
        // { displayName: "Area Code", key: "areaCode" },
        { displayName: "ZipCode", key: "ZipCode" },
        { displayName: "Charge Amount", key: "chargedAmount" },
        { displayName: "QR Code", key: "LPA" },
        { displayName: "Account Number", key: "AccountNumber" },
        { displayName: "PIN", key: "PIN" },
        { displayName: "Remark", key: "Remarks" },
    ];

    const filteredItems = useMemo(() => {
        return Array.isArray(activationBatchReports) && activationBatchReports.length > 0
            ? activationBatchReports.filter(item => {
                if (!searchItem) return true;
                return Object.values(item).some(val => typeof val === "string" && val.toLowerCase().includes(searchItem.toLowerCase()));
            })
            : [];
    }, [activationBatchReports, searchItem]);

    const rowData = useMemo(() => {
        return (filteredItems || []).map((item) => ({
            TxnType: item?.TxnType == 26 ? 'eSIM' : 'pSIM',
            BATCHID: item?.BatchID,
            TXNID: item?.TransactionID,
            SERIALNUMBER: item?.SERIALNUMBER,
            MSISDN: item?.MobileNumber,
            Status: (<span className={`badge ${item?.StatusID == 14 ? "bg-warning" : item?.StatusID == 15 ? 'bg-success' : item?.StatusID == 16 ? "bg-danger" : 'bg-info'}`}
            > {item?.Status} </span>),
            DESCRIPTION: item?.Description,
            MONTHTEXT: item?.Month,
            Remarks: item?.Remarks,
            // areaCode: item?.AreaCode ?? '-',
            ZipCode: item?.ZipCode,
            chargedAmount: defaultCurrency + '' + item?.ChargedAmount,
            LPA: item?.LPA ? (
                <div style={{ display: "flex", justifyContent: "center", cursor: "pointer", }} onClick={() => handleQRClick(item)} > <QRCode value={String(item.LPA)} size={25} /> </div>) : "",
            AccountNumber: item?.AccountNumber,
            PIN: item?.PIN,

        }));
    }, [filteredItems]);

    const handleBack = () => {
        onBack();
    }

    const handleExportExcel = () => {
        const data = filteredItems.map(item => ({
            "Batch ID": item["BatchID"],
            "Type": item?.TxnType == 26 ? 'eSIM' : 'pSIM',
            "Transaction ID": item["TransactionID"],
            "Serial Number": item["SERIALNUMBER"],
            "MSISDN": item["MobileNumber"],
            "Status": item["Status"],
            "Description": item["Description"],
            "Month": item["Month"],
            // "Area Code": item?.AreaCode,
            "ZipCode": item["ZipCode"],
            "Charge Amount": item["ChargedAmount"],
            "LPA": item["LPA"],
            "Account Number": item["AccountNumber"],
            "PIN": item["PIN"],
            "Remarks": item["Remarks"],
        }));

        downloadExcelSampleFile(data, "activation-batch-detail.xlsx");
    };

    return (
        <CardLayout
            title={<> Activation Batch Details<span style={{ color: "#4b9b60" }}> :#{selectedBatchId}
            </span>
            </>
            }
            icon="ri-file-chart-line "
            rightContent={
                <div className="d-flex flex-wrap align-items-center gap-1">
                    <input
                        type="search"
                        style={{ width: "300px", }}
                        onChange={(e) => setSearchItem(e.target.value)}
                        className="form-control form-control-sm"
                        placeholder="Search..." />
                    <div className="d-flex gap-2">
                        <Button
                            title="Back"
                            buttonType="button"
                            icon={<i className="ri-arrow-left-line me-1" />}
                            variant="primary"
                            style={{
                                padding: "5px 10px",
                            }}
                            onClick={() => handleBack()}
                        />
                        <Button
                            title="Excel"
                            buttonType="button"
                            variant="secondary"
                            onClick={handleExportExcel}
                            icon={<i className="ri-download-cloud-line me-2" />}
                        />
                    </div>
                </div>
            }
        >

            {/* Table */}
            <div className="mt-2">
                <Table
                    columns={columns}
                    data={rowData}
                    pagination
                    loading={activationBatchReportsLoading}
                    tableHeight="285px"
                />
            </div>
            <Modal
                  title={'QR Code Details'}
                // title={selectedQrData?.TransactionID || 'QR Code'}
                showModal={showQRModal}
                onHide={handleCloseQR}
                showFooter={false}
                width={385}
            >
                <div className="d-flex flex-column justify-content-center pb-2">
                    <div
                        className="mb-3"
                        style={{ display: "flex", justifyContent: "center", }}
                    >
                        {selectedQrData?.LPA && (
                            <div className="shadow p-3 bg-body-tertiary rounded">
                                <QRCode value={selectedQrData?.LPA} size={180} />
                            </div>
                        )}
                    </div>

                    <div className="d-flex justify-content-between mb-1">
                        <div className="text-primary fw-5 fw-semibold me-2" style={{ fontSize: "14px" }}>MSISDN</div>
                        <small className="px-2" style={{ fontSize: "12px", overflowWrap: "anywhere", wordBreak: "break-word", }}>{selectedQrData?.MobileNumber ?? ''}</small>
                    </div>
                    <div className="d-flex mb-1 justify-content-between">
                        <div className="text-primary fw-5 fw-semibold me-2" style={{ fontSize: "14px" }}>Serial Number</div>
                        <small className="px-2" style={{ fontSize: "12px", overflowWrap: "anywhere", wordBreak: "break-word", }}>{selectedQrData?.SERIALNUMBER ?? ''}</small>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="text-primary fw-5 fw-semibold me-2" style={{ fontSize: "14px" }}>LPA</div>
                        <small className="px-2" style={{ fontSize: "12px", overflowWrap: "anywhere", wordBreak: "break-word" }}>{selectedQrData?.LPA ?? ''}</small>
                    </div>
                </div>
            </Modal>
        </CardLayout>

    );
};

export default ActivationBatchDetails;

